export enum DataHooks {
  ROOT = 'service-info-title-root',
  LINK = 'service-info-title-link',
  TEXT = 'service-info-title-text',
}
